module.exports = __webpack_public_path__ + "assets/3f1e45c9f79088571e8de1db1231f580.png";